<template>
  <component :is="component" :id="id" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import types from '@/modules/inhabitant_changes/common/types';

export default {
  name: 'Request',

  components: {
    RequestCheckIn: () =>
      import('@/modules/inhabitant_changes/components/requests/RequestCheckIn'),
    RequestCheckOut: () =>
      import('@/modules/inhabitant_changes/components/requests/RequestCheckOut')
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: prop => Object.values(types).includes(prop)
    }
  },

  computed: {
    component() {
      return `request-${this.type}`;
    }
  }
};
</script>
